<template>
       <v-layout
                row
                wrap            >
                            <!--<timeoutvue />
                          <v-row >

                                            <div class="loader" cols="12" md="12">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                    </v-row>

                        -->

            <v-row wrap>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-skeleton-loader
                    class="mx-auto "
                    type="card"
                    ></v-skeleton-loader>

                  </v-col>
                  <v-col
                    cols="12"
                      md="12"
                       >
                           <div class="row grey lighten-6 text-center pa-1 mt-n2">
            <v-container style="max-width: 1366px" id="cards">
                <v-layout row wrap>

                    <v-flex md4 sm12 xs12 class="d-block">
                        <div class="text-center red--text text--darken-5 pb-6 mt-6">
                        <v-skeleton-loader
                        class="mx-auto "
                        type="image"
                        ></v-skeleton-loader>
                        </div>
                    </v-flex>

                    <v-flex md4 sm12 xs12 class="d-block">
                        <div class="text-center white--text pb-6 mt-6">
                            <v-skeleton-loader
                            class="mx-auto  blue darken-5"
                            type="image"
                            ></v-skeleton-loader>
                            </div>
                    </v-flex>
                    <v-flex md4 sm12 xs12 class="d-block">
                            <div class="boxfocus text-center blue--text text--darken-5 pb-6 mt-6 ">
                            <v-skeleton-loader
                            class="mx-auto"
                            type="image"
                            ></v-skeleton-loader>
                            </div>
                    </v-flex>


                    <v-flex md4 sm12 xs12 class="d-block">
                        <div class="text-center white--text">
                        <v-skeleton-loader
                                class="mx-auto red darken-5"
                                type="image"
                                ></v-skeleton-loader>
                        </div>
                    </v-flex>
                    <v-flex md4 sm12 xs12 class="d-block">
                                    <div class="boxfocus text-center ">
                                <v-skeleton-loader
                                class="mx-auto "
                                type="image"
                                ></v-skeleton-loader>
                                </div>

                    </v-flex>
                     <v-flex md4 sm12 xs12 class="d-block">
                            <div class="text-center white--text">
                            <v-skeleton-loader
                                    class="mx-auto red darken-5"
                                    type="image"
                                    ></v-skeleton-loader>
                            </div>
                        </v-flex>
                </v-layout>
            </v-container>
        </div>

    </v-col>
                   <v-col
                        cols="12"
                          md="12"
                           >
                               <v-container style="max-width: 1380px">
                <v-layout class="mx-auto">
                    <v-row cols="12" xs="12" class="text-left justify-center">
                        <v-col cols="3" offset="0" class="text-left pa-6 ma-6">
      <v-skeleton-loader
                                        class="mx-auto red darken-5"
                                        type="list-item-two-line"
                                        ></v-skeleton-loader>
                        </v-col>
                    </v-row>
                </v-layout>
                <v-layout row wrap>

                        <v-flex md4 sm12 xs12 class="d-block">
                                        <div class="boxfocus text-center pa-6">
                                    <v-skeleton-loader
                                    class="mx-auto "
                                    type="image"
                                    ></v-skeleton-loader>
                                    </div>

                        </v-flex>
                                                <v-flex md4 sm12 xs12 class="d-block pa-6 ">
                                            <div class="boxfocus text-center ">
                                        <v-skeleton-loader
                                        class="mx-auto "
                                        type="image"
                                        ></v-skeleton-loader>
                                        </div>

                            </v-flex>
                                                    <v-flex md4 sm12 xs12 class="d-block pa-6">
                                            <div class="boxfocus text-center ">
                                        <v-skeleton-loader
                                        class="mx-auto "
                                        type="image"
                                        ></v-skeleton-loader>
                                        </div>

                            </v-flex>
                </v-layout>
                <div class="pa-8 text-center">

                </div>
            </v-container>
                        </v-col>
</v-row>


</v-layout>



</template>

<script>
export default {
    data: () => ({
        attrs: {
            boilerplate: true,
            elevation: 3
        }
    })
};
</script>
<style scoped>
.loader {
    text-align: center;
    vertical-align: middle;
    position: absolute;
    top: 0;

    display: flex;
    padding: 150px;
    box-shadow: 0px 40px 60px -20px rgba(0, 0, 0, 0.2);
}

.loader span {
    display: block;
    width: 20px;
    height: 20px;
    background: #eee;
    border-radius: 50%;
    margin: 0 5px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
}

.loader span:nth-child(2) {
    background: #f07e6e;
}

.loader span:nth-child(3) {
    background: #84cdfa;
}

.loader span:nth-child(4) {
    background: #5ad1cd;
}

.loader span:not(:last-child) {
    animation: animate 1.5s linear infinite;
}

@keyframes animate {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(30px);
    }
}

.loader span:last-child {
    animation: jump 1.5s ease-in-out infinite;
}

@keyframes jump {
    0% {
        transform: translate(0, 0);
    }
    10% {
        transform: translate(10px, -10px);
    }
    20% {
        transform: translate(20px, 10px);
    }
    30% {
        transform: translate(30px, -50px);
    }
    70% {
        transform: translate(-150px, -50px);
    }
    80% {
        transform: translate(-140px, 10px);
    }
    90% {
        transform: translate(-130px, -10px);
    }
    100% {
        transform: translate(-120px, 0);
    }
}
</style>
